import types from 'pages/PaymentSlip/actions/type.js';
import { defaultPaging } from 'utils/helpers';

const INITIAL_STATE = {
  paymentSlipList: defaultPaging,
  paymentSlipData: undefined,
  getListLoading: false,
  getDetailLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  ordersList: undefined,
  getOrdersLoading: false,
  paymentSlipCode: undefined,
  getCodeLoading: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.GET_LIST_PAYMENTSLIP_REQUEST:
      return {
        ...state,
        getListLoading: true,
      };
    case types.GET_LIST_PAYMENTSLIP_SUCCESS: {
      return {
        ...state,
        paymentSlipList: action.payload,
        getListLoading: false,
      };
    }
    case types.GET_LIST_PAYMENTSLIP_FAILURE:
      return {
        ...state,
        getListLoading: false,
      };
    case types.GET_DETAIL_PAYMENTSLIP_REQUEST:
      return {
        ...state,
        getDetailLoading: true,
      };
    case types.GET_DETAIL_PAYMENTSLIP_SUCCESS: {
      return {
        ...state,
        paymentSlipData: action.payload,
        getDetailLoading: false,
      };
    }
    case types.GET_DETAIL_PAYMENTSLIP_FAILURE:
      return {
        ...state,
        getDetailLoading: false,
      };
    case types.CREATE_REQUEST:
      return {
        ...state,
        createLoading: true,
      };
    case types.CREATE_SUCCESS:
    case types.CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
      };
    case types.UPDATE_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case types.UPDATE_SUCCESS:
    case types.UPDATE_FAILURE:
      return {
        ...state,
        updateLoading: false,
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };
    case types.DELETE_SUCCESS:
    case types.DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
      };
    //get order list
    case types.GET_LIST_ORDER_REQUEST:
      return {
        ...state,
        getOrdersLoading: true,
      };
    case types.GET_LIST_ORDER_SUCCESS: {
      return {
        ...state,
        ordersList: action.payload,
        getOrdersLoading: false,
      };
    }
    case types.GET_LIST_ORDER_FAILURE:
      return {
        ...state,
        getOrdersLoading: false,
      };

    //get code
    case types.GET_CODE_PAYMENTSLIP_REQUEST:
      return {
        ...state,
        getCodeLoading: true,
      };
    case types.GET_CODE_PAYMENTSLIP_SUCCESS: {
      return {
        ...state,
        paymentSlipCode: action.payload,
        getCodeLoading: false,
      };
    }
    case types.GET_CODE_PAYMENTSLIP_FAILURE:
      return {
        ...state,
        getCodeLoading: false,
      };

    default:
      return state;
  }
}
